import gsap from 'gsap';
import imagesLoaded from 'imagesloaded';
import RytmWebflow from 'rytm-webflow'
import { scrollToTargetForce } from '../scrolling';


class ChapterOpeningView extends RytmWebflow.WebflowView {

  constructor(id) {
    super(id);
    this.isLoading = false;
    this.dataLoaded = false;
  }
  /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container);
    this.container = container;
    if (!this.scrollTriggersInitialized) {
      this.scrollTriggersInitialized = true;
      this.initScrollTriggers();
    }
    if (!this.isLoading) {
      this.isLoading = true;
      imagesLoaded(container, { background: true}, (instance) => {
        this.onImagesLoaded();
      });
    }
    if (this.dataLoaded) {
      this.initImages();
    }
    gsap.set(container, {
      autoAlpha: 1,
      y: 0,
    });
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    if (this.dataLoaded) {
      this.destroyImages();
    }
    this.hideImages(container);
    super.hide(container);
  }
  /**
   * #######################
   * ### Scroll Triggers ###
   */
  initScrollTriggers = () => {
    // scrollTrigger for HIDE chapter opening
    // calculate header height
    const header = document.documentElement.querySelector('.header-fixed');
    const headerHeight = header ? header.offsetHeight : 0;
    // scroll Trigger to open next section
    gsap.to(this.container, {
      scrollTrigger: {
        toggleActions: "restart none none reverse",
        trigger: this.container,
        start: 'top ' + (headerHeight - 2) + "px",
        // markers: true,
        onEnter: () => {
          // wait (give time to fire click trigger)
          setTimeout(() => {
            scrollToTargetForce('.chapter-content', {offset: -80});
          }, 100);
        },
      },
    });
    // hide IMAGES
    gsap.to('.chapter-images', {
      scrollTrigger: {
        toggleActions: "restart none none reverse",
        trigger: this.container,
        start: 'top top',
        end: 'bottom center',
        // markers: true,
        scrub: true,
      },
      opacity: 0,
      ease: 'power2.inOut',
    });
    // hide FOOTER
    gsap.to('.chapter-opening-footer', {
      scrollTrigger: {
        toggleActions: "restart none none reverse",
        trigger: this.container,
        start: 'top top',
      },
      y: "100%",
      duration: .6,
      ease: 'power2.inOut',
    });
  }
  /**
   * ### End: Scroll Triggers ###
   * ############################
   */
  /**
   * ######################
   * ### Opening Images ###
   */
  onImagesLoaded = () => {
    this.dataLoaded = true;
    if (this.active) {
      this.initImages();
    }
  }
  destroyImages = () => {
    // console.log("DESTROY IMAGES!!!", this.container);
    // @todo destroy images
  }
  initImages = () => {
    if (!this.active) {
      return;
    }
    const list = [...this.container.querySelectorAll('.image-wrapper')];
    const wW = window.innerWidth;
    const wH = window.innerHeight;
    list.forEach((el, index) => {
      // get current X and Y position (store for 2'nd time show is fired)
      const myX = el.dataset.initX || gsap.getProperty(el, 'x');
      const myY = el.dataset.initY || gsap.getProperty(el, 'y');
      el.dataset.initX = myX;
      el.dataset.initY = myY;
      this.myY = myY;
      const startX = myX > 0 ? wW : -wW;
      const startY = myY > 0 ? wH : -wH;
      gsap.set(el, {x: startX, y: startY, "visibility": "visible"});
      gsap.to(el, {
        x: myX,
        y: myY,
        duration: 1,
        delay: 0.08 * index + .5,
        ease: 'power3.out',
      });
    });
  }
  hideImages = (container) => {
    gsap.killTweensOf(container);
    gsap.to(container, {
      autoAlpha: 0,
      duration: .7,
      y: "-50%",
      ease: 'power2.inOut',
    });
  }
  /**
   * ### End: Opening Images ###
   * ###########################
   */
  

}

export default ChapterOpeningView